import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/product/finance/finance-jd1.png';
const _withScopeId = n => (_pushScopeId("data-v-0062d0ad"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "dis-space-4 me-max-title"
}, "数字金融", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "info dis-space-2 me-main-title"
}, "基于网货业务场景，为上下游客户提供便捷、高效的融资渠道，满足客户资金需求", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "industry-title me-max-title"
}, "行业痛点及现状", -1));
const _hoisted_5 = {
  class: "industry-list me-top-lg"
};
const _hoisted_6 = {
  class: "me-ml-title"
};
const _hoisted_7 = {
  class: "me-content-vl"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "me-sub-title"
}, " 货达基于“发运收”环节上游结构化的运输数据，穿透运输过程，通过数据交叉验证确保运输真实性。基于真实的运输数据，携手金融机构，为运输企业打造定制化金融产品，助力企业获得融资。 ", -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "safeness-title me-max-title me-top-max"
}, "平安e融资", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "safeness-des"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "me-content-vl"
}, "携手头部金融机构，帮助车队长、贸易商及合作伙伴完成授信融资，随取随用，即时到账，助力企业扩大业务规模，降低营运成本。")], -1));
const _hoisted_12 = {
  class: "safeness-adv me-top-max"
};
const _hoisted_13 = {
  class: "safeness-adv-list"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "me-content-vl me-top-lt"
};
const _hoisted_16 = {
  class: "me-content-lt"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "safeness-adv-line"
}, null, -1));
const _hoisted_18 = {
  class: "safeness-condition me-top-max"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "me-main-title"
}, "申请条件", -1));
const _hoisted_20 = {
  class: "safeness-condition-info me-top-lt"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "me-sub-titl"
}, "• 车队长征信良好且无异常记录； • 货主方为资信良好优质企业； • 车队长已与货达合作超过3个月", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "loan-title me-max-title"
}, "京东运费贷", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loan-des me-top me-content-vl"
}, " 针对使用货达平台的货主，以物流运单为核心，申请流程便捷高效，可使用产品定向支付运费，无担保无抵押，有效帮助缓解资金压力。 ", -1));
const _hoisted_24 = {
  class: "loan-process me-top-max"
};
const _hoisted_25 = {
  class: "loan-process-content"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "process-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_27 = {
  class: "process-des"
};
const _hoisted_28 = {
  class: "me-content-vl"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_31 = {
  class: "me-content-vl"
};
const _hoisted_32 = {
  class: "loan-adv me-top-lt"
};
const _hoisted_33 = ["src"];
const _hoisted_34 = {
  class: "adv-title me-content-vl me-top-lt"
};
const _hoisted_35 = {
  class: "adv-content me-content-lt"
};
const _hoisted_36 = {
  class: "loan-condition me-top-max"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "me-main-title"
}, "申请条件", -1));
const _hoisted_38 = {
  class: "loan-condition-info me-top-lt"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "me-sub-titl"
}, "• 货主企业征信良好，无恶意逾期及不良贷款记录； • 货主企业不涉及重大诉讼； • 与货达合作时间超过6个月", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_ConsultModal = _resolveComponent("ConsultModal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "banner-box",
    style: _normalizeStyle({
      height: _ctx.bannerHeight
    })
  }, [_createElementVNode("div", {
    class: "banner-info",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_2, _hoisted_3, _createVNode(_component_a_button, {
    class: "service me-content-lt",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.openConsultModdal())
  }, {
    default: _withCtx(() => [_createTextVNode("立即咨询")]),
    _: 1
  })], 4)], 4), _createElementVNode("div", {
    class: _normalizeClass(["industry me-top-lg", {
      'industry-entry': _ctx.industryState.showTime
    }]),
    id: "industry"
  }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "industry-list-item",
      key: index
    }, [_createElementVNode("span", null, "0" + _toDisplayString(index + 1), 1), _createElementVNode("h3", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("label", _hoisted_7, _toDisplayString(item.content), 1)]);
  }), 128))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["theme me-padding-H1", {
      'theme-entry': _ctx.themeState.showTime
    }]),
    id: "theme"
  }, _hoisted_9, 2), _createElementVNode("div", {
    class: _normalizeClass(["safeness me-padding-H1", {
      'safeness-entry': _ctx.safenessState.showTime
    }]),
    id: "safeness"
  }, [_hoisted_10, _hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safeness, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "safeness-adv-item",
      key: index
    }, [_createElementVNode("img", {
      class: "me-top-lt",
      src: item.img,
      alt: ""
    }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_16, _toDisplayString(item.content), 1)]);
  }), 128))]), _hoisted_17]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_hoisted_21, _createVNode(_component_a_button, {
    class: "safeness-condition-btn me-sub-title",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.openConsultModdal())
  }, {
    default: _withCtx(() => [_createTextVNode("立即申请")]),
    _: 1
  })])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["loan me-padding-H1 me-top-max", {
      'loan-entry': _ctx.loanState.showTime
    }]),
    id: "loan"
  }, [_hoisted_22, _hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "process-des-item",
      key: index
    }, [_createElementVNode("p", null, [_createElementVNode("span", _hoisted_28, "0" + _toDisplayString(index + 1), 1), _hoisted_29, _hoisted_30, _createElementVNode("span", _hoisted_31, _toDisplayString(item.content), 1)])]);
  }), 128))])])]), _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanAdv, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "loan-adv-item",
      key: index
    }, [_createElementVNode("img", {
      src: item.img,
      alt: ""
    }, null, 8, _hoisted_33), _createElementVNode("div", _hoisted_34, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_35, _toDisplayString(item.content), 1)]);
  }), 128))]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, [_hoisted_39, _createVNode(_component_a_button, {
    class: "loan-condition-btn me-sub-title",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.openConsultModdal())
  }, {
    default: _withCtx(() => [_createTextVNode("立即申请")]),
    _: 1
  })])])], 2), _createVNode(_component_ConsultModal, {
    ref: "consultModalRef"
  }, null, 512)]);
}